export class ListingController {
    constructor() {
      'ngInject';
    }

    onPageClicked(page, offset) {
      this.onPaginate({offset: offset});
    }
  }
  
  export default ListingController;
  


// WEBPACK FOOTER //
// ./client/app/pages/customer/betoverview/component/bets/component/listing.controller.js